<span class="snackbar-title">{{data.message}}</span>
<ul class="snackbar-list">
    <li *ngFor="let item of data.list">{{ item }}</li>
</ul>